<template>
  <div id="myIncome">
    <v-header title="个人收入"></v-header>
    <!-- <div class="conH"></div> -->
    <div class="main">
      <div class="main-header">
        <label><span v-show="isShowIncome">{{yeararrY}}年{{montharrI}}</span>月收入</label>
        <div class="picker">
          <el-date-picker type="month"  @change="onloads()" size="mini" value-format="yyyy-MM" :editable='false' :clearable='false' v-model="month" :picker-options="pickerOptions0">
          </el-date-picker>
        </div>
      </div>
      <div class="main-content">
        <div class="content-top">
            <div class="content-top-left">
                <label>实发(元)</label>
                <span>{{result.awi125}}</span>
            </div>
            <div class="content-top-left">
                <label>应发(元)</label>
                <span>{{result.awm099}}</span>
            </div>
        </div>
        <div class="myChart">
          <div v-show="nodata" style="text-align: center;font-weight: bold;line-height: 140px">暂无数据</div>
          <div v-show="!nodata" id="myChart" style=" width:100%;height:100%"></div></div>
      </div>
    </div>
    <div class="tables">
      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane label="收入明细" name="first">
          <el-collapse style="margin-bottom:15px;" v-if="result&&(JSON.stringify(result.firstRenewalComm) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>首续期佣金</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.firstRenewalComm" :key="index"><span class="left">{{key}}</span><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse style="margin-bottom:15px;" v-if="result&&(JSON.stringify(result.performAndHiring) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>绩效增员</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.performAndHiring" :key="index"><span class="left">{{key}}</span><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse style="margin-bottom:15px;" v-if="result&&(JSON.stringify(result.manageAndBred) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>管理+育成津贴</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span >项目</span><span class="right">金额</span></div>
                <div><span >项目</span><span class="right">金额</span></div>
                <div><span >项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.manageAndBred" :key="index"><span class="left">{{key}}</span><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse style="margin-bottom:15px;" v-if="result&&(JSON.stringify(result.hiredToAllowance) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>聘才津贴</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.hiredToAllowance" :key="index"><span class="left">{{key}}</span><i></i><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse style="margin-bottom:15px;" v-if="result&&result.comDevelop!=undefined&&(JSON.stringify(result.comDevelop) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>综合开拓津贴</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.comDevelop" :key="index"><span class="left">{{key}}</span><i></i><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse style="margin-bottom:15px;" v-if="result&&result.comWelfare!=undefined&&(JSON.stringify(result.comWelfare) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>综合福利津贴</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.comWelfare" :key="index"><span class="left">{{key}}</span><i></i><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse style="margin-bottom:15px;" v-if="result&&(JSON.stringify(result.otherIncome) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>其他</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.otherIncome" :key="index"><span class="left">{{key}}</span><i></i><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse style="margin-bottom:15px;" v-if="result&&(JSON.stringify(result.tax) != '{}')">
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>税收</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.tax" :key="index"><span class="left">{{key}}</span><i></i><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>

        </el-tab-pane>

        <el-tab-pane label="加扣款明细" name="second">

          <el-collapse style="margin-bottom:15px;" ><!-- v-if="result&&(JSON.stringify(plusAnddeducts.plusMoney) != '{}')" -->
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>加款项目</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>

              <div class="first-content procon">
                 <div class="first-content procon"> 合计(税前/税后)<span class="right">{{plusAnddeducts.beforeTaxPlusMoney}}/{{plusAnddeducts.afterTaxPlusMoney}}</span>  </div>

                <div v-for="(item,key,index) in plusAnddeducts.plusMoney" :key="index" > <!-- v-show="index===1" -->
                 <span class="left">{{key}}
                  <el-tooltip class="item" effect="dark" :content="result.remarkMap[key]" placement="top-start">
                    <img :src = "commentadd === index ? commentsrclan : commentsrchui" class="comment" @mouseover="commentsadd($event,index)" @mouseout="commentsoutadd($event,index)"/>
                    </el-tooltip></span><i></i><span class="right">{{item}}</span></div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse style="margin-bottom:15px;"><!--  v-if="result&&(JSON.stringify(plusAnddeducts.deductMoney) != '{}')" -->
            <el-collapse-item title="首续期佣金" name="1">
              <template slot="title">
                <div class="first-title">
                  <label>扣款项目</label>
                </div>
              </template>
              <div class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div class="first-content procon">合计(税前/税后) <span class="right">{{plusAnddeducts.beforeTaxDeductMoney}}/{{plusAnddeducts.afterTaxDeductMoney}}</span></div></div>

              <!-- <div class="first-content procon">
                <div v-for="(item,key,index) in plusAnddeducts.deductMoney" :key="index"><span class="left">{{key}}<el-tooltip class="item" effect="dark" :content="key+item" placement="top-start"><img :src = "commentminus === index ? commentsrclan : commentsrchui" class="comment" @mouseover="commentsminus($event,index)" @mouseout="commentsoutminus($event,index)"/></el-tooltip></span><i></i><span class="right">{{item}}</span></div>
              </div> -->
            </el-collapse-item>
          </el-collapse>

        </el-tab-pane>
        <el-tab-pane style="font-size:13px;line-height:24px;" label="参考科目" name="third">
              <div  class="first-Projectamount procon" >
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div><span class="left">项目</span><span class="right">金额</span></div>
                <div class="border-right"><span class="left">项目</span><span class="right">金额</span></div>
              </div>
              <div class="first-content procon">
                <div v-for="(item,key,index) in result.referSubject" :key="index"><span class="left">{{key}}</span><i></i><span class="right">{{item}}</span></div>
              </div>

        </el-tab-pane>
        <el-tab-pane class="top-four" label="保单明细" name="fourth">
          <div class="first-titles">
            <span>保单号</span>
            <span>投保人</span>
            <span style="width:17%">产品</span>
            <span>险种</span>
            <span>首/续期</span>
            <span>缴费年限</span>
            <span>保费</span>
            <span>佣金率</span>
            <span>佣金</span>
            <span>佣金折扣</span>
            <span style="width:9%">额外销售奖金比率</span>
            <span>额外销售奖金</span>
            <span>承保日</span>
            <span>标志</span>
          </div>
          <div v-for="(item,key,index) in result.policys" :key="index" class="first-contents">
            <span>{{item.policyNo}}</span>
            <span>{{item.lifeName}}</span>
            <span style="width:17%">{{item.product}}</span>
            <span>{{item.component}}</span>
            <span>{{item.bizType}}</span>
            <span>{{item.premterm}}</span>
            <span>{{item.permium}}</span>
            <span>{{item.commRate}}</span>
            <span>{{item.bonus}}</span>
            <span>{{item.renewalDiscount}}</span>
            <span style="width:9%">{{item.extraSaleRate}}</span>
            <span>{{item.extraBonus}}</span>
            <span>{{item.firstIssueDate}}</span>
            <span>{{item.stateId}}</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api'
import echarts from 'echarts'
import { log } from 'util'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
      plusplusMoney: '',
      loading: true,
      req: {
        PID: '',
        MONTH: '',
        SEARCHTYPE: 'P',
        SHEETFLAG: '',
        startIndex: '0',
        limit: '100',
        orderBy: ''
      },
      plusAnddeducts: '',
      activeName: 'first',
      activeNames: [''],
      month: '', // 默认查询时间
      keep: '',
      currMonth: '',
      montharrI:'',
      yeararrY:'',
      isShowIncome:false,
      promote: '',
      slength: [],
      rlength: [],
      sslength: [],
      rrlength: [],
      result: {},
      pickerOptions0: {
        disabledDate (time) {
          let now = new Date() // 当前日期
          let nowYear = now.getFullYear() // 当前年
          let lastMonthDate = new Date() // 上月日期

          lastMonthDate.setDate(1)
          lastMonthDate.setMonth(lastMonthDate.getMonth())
          let lastMonth = lastMonthDate.getMonth()
          // alert(nowYear);
          if (lastMonth == 0) {
            nowYear = nowYear - 1
            lastMonth = 11
          }
          let lastMonthStartDate = new Date(nowYear, lastMonth, 1)
          return time.getTime() >= lastMonthStartDate.getTime()
        }
      },
      nodata: false,
      count: 0,
      commentsrchui: 'static/image/beizhuhui.png',
      commentsrclan: 'static/image/beizhulan.png',
      commentadd: '',
      commentminus: ''
    }
  },
  watch: {
    month: function (news, old) {
      let values = news
      let temp = values.split("-").join("");
      let arrI = temp.slice(4, 6)
      let arrY = temp.slice(0, 4)
      this.montharrI = arrI
      this.yeararrY = arrY
      if (arrI === '01') {
        this.currMonth = '一'
      } else if (arrI === '02') {
        this.currMonth = '二'
      } else if (arrI === '03') {
        this.currMonth = '三'
      } else if (arrI === '04') {
        this.currMonth = '四'
      } else if (arrI === '05') {
        this.currMonth = '五'
      } else if (arrI === '06') {
        this.currMonth = '六'
      } else if (arrI === '07') {
        this.currMonth = '七'
      } else if (arrI === '08') {
        this.currMonth = '八'
      } else if (arrI === '09') {
        this.currMonth = '九'
      } else if (arrI === '10') {
        this.currMonth = '十'
      } else if (arrI === '11') {
        this.currMonth = '十一'
      } else if (arrI === '12') {
        this.currMonth = '十二'
      }
    },
    result: function (news, old) {
      var that = this
      console.log(news, old)
      setTimeout(function () {
        that.drawLine(news)
      })
    }
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll,true)
  },
  activated () {
    this.initPage()
    this.count = 0
    this.month = this.changeDates()
    // 首次进入转换大小写
    let values = this.changeDates()
    let arrI = values.slice(4, 6)
    let arrY = values.slice(0, 4)
    this.montharrI = arrI
    this.yeararrY = arrY
    if (arrI === '01') {
      this.currMonth = '一'
    } else if (arrI === '02') {
      this.currMonth = '二'
    } else if (arrI === '03') {
      this.currMonth = '三'
    } else if (arrI === '04') {
      this.currMonth = '四'
    } else if (arrI === '05') {
      this.currMonth = '五'
    } else if (arrI === '06') {
      this.currMonth = '六'
    } else if (arrI === '07') {
      this.currMonth = '七'
    } else if (arrI === '08') {
      this.currMonth = '八'
    } else if (arrI === '09') {
      this.currMonth = '九'
    } else if (arrI === '10') {
      this.currMonth = '十'
    } else if (arrI === '11') {
      this.currMonth = '十一'
    } else if (arrI === '12') {
      this.currMonth = '十二'
    }
    this.getPersonalIncome(this.month)
  },
  beforedestroy(){
     window.removeEventListener('scroll', this.handleScroll,true)
  },
  beforeRouteLeave(to, from, next) {
      this.isShowIncome = false
      next();
  },
  methods: {
    handleScroll () {
      var scrollTop = document.querySelector('#myIncome').scrollTop
      // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if(scrollTop > 435){
        document.querySelector('.el-tabs__header').classList.add('titleHeader')
      }else{
        document.querySelector('.el-tabs__header').classList.remove('titleHeader')
      }
    },

    initPage () { // 初始化页面
      this.activeName = 'first'
    },
    // 改变时间的时候重新刷新数据
    onloads () {
      this.getPersonalIncome(this.month)
    },
    changeDates () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month < 10) {
        var ymonth = '0' + month
      } else {
        ymonth = month
      }
      let time = year + '' + ymonth
      return time
    },
    // 请求接口
    getPersonalIncome (datas) {
      console.log(datas)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let str = datas.replace('-', '')
      console.log(str)
      let submitInfo =
        {
          'PID': sessionStorage.getItem('username'),
          'MONTH': str
        }
      let that = this
      // 调用接口保存告知数据
      api.getPersonalIncome(submitInfo, function (res) {
        if (res.result.isSuccess === true) {
          loading.close()
          that.isShowIncome = true
          that.nodata = false
          that.result = res.data.data?res.data.data:{}
          //   转存扣款数据
          that.plusAnddeducts = that.result.plusAnddeduct?that.result.plusAnddeduct:{}
          that.plusplusMoney = 0
          that.plusdeductMoney = 0
          // that.plusplusMoney = that.plusAnddeducts.plusMoney['税前加款']
          for (let key in that.plusAnddeducts.plusMoney) {
            that.plusplusMoney += Number(that.plusAnddeducts.plusMoney[key])
          }
          // for (let key in that.plusAnddeducts.plusMoney) {
          //   console.log('循环', that.plusAnddeducts.plusMoney[key])

          // }

          for (let key in that.plusAnddeducts.deductMoney) {
            that.plusdeductMoney += Number(that.plusAnddeducts.deductMoney[key])
          }
          console.log(that.plusAnddeducts, '加扣款项')
          that.month = str.slice(0, 4) + '-' + str.slice(4, 6)
          console.log(that.month)
          console.log(that.result, 'result---------')
          
        } else {
          // that.$toast('请于月底最后一天查看上月工资明细')
          // //   查询失败 显示日期回到当前日期
          // that.tiInitialization = that.changeDates(that.currentDate)
          // that.tiIn(that.tiInitialization)
          //   N+1月查看N月工资明细
          if (that.count < 3) {
            console.log(datas, that.count)
            let year = datas.slice(0, 4)
            let month = datas.slice(4, 6)
            let date = year + '/' + month + '/' + '01'
            let now = new Date(date)
            let perMonth = new Date(now.setMonth(now.getMonth() - 1))
            let monthDate = perMonth.getMonth() + 1
            if (monthDate < 10) {
              monthDate = '0' + monthDate
            }
            let reqDate =
              perMonth.getFullYear() + '' + monthDate
            that.getPersonalIncome(reqDate)
            that.count++
          } else {
            loading.close();
            that.isShowIncome = true
            that.result.awi125 = 0
            that.result.awm099 = 0
            that.result.referSubject = ''
            that.result.referSubject = ''
            that.result.tax = ''
            that.result.otherIncome = ''
            that.result.comWelfare = ''
            that.result.comDevelop = ''
            that.result.hiredToAllowance = ''
            that.result.manageAndBred = ''
            that.result.performAndHiring = ''
            that.result.firstRenewalComm = ''
            that.result.policys = ''
            if (that.plusAnddeducts.plusMoney) {
              that.plusAnddeducts.plusMoney = ''
            }
            if (that.plusAnddeducts.deductMoney) {
              that.plusAnddeducts.deductMoney = ''
            }
            that.nodata = true
            // that.$toast(res.result.error)
          }
        }
      })
    },
    commentsadd (event, index) {
      this.commentadd = index
    },
    commentsoutadd (event, index) {
      this.commentadd = ''
    },
    commentsminus (event, index) {
      this.commentminus = index
    },
    commentsoutminus (event, index) {
      this.commentminus = ''
    },

    drawLine (datas) {
      // 基于准备好的dom，初始化echarts实例
      let awm09 = datas.awm099
      let myChart = echarts.init(document.getElementById('myChart'))
      //   console.log(datas)
      //   let awm09 = datas.awm099
      let options = {
        title: { // 标题，
          // text: `应发\n` + awm09, // 主标题文本，
          text: `应发`, // 主标题文本，
          textStyle: { // 主标题文本样式
            fontSize: 16,
            color: '#5976BA',
            fontWeight: '600'
          },
          subtext: awm09,
          subtextStyle: {
            fontSize: 16,
            color: '#5976BA',
            fontWeight: '600'
          },
          x: 'center', // 水平安放位置，默认为左侧，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
          y: '42%'
        },

        tooltip: {
          trigger: 'item',
          // formatter: '{a} {b}: ({d}%)<hr>{c} ',
          textStyle: {
            align: 'center'
          },
          //
          padding: 10,
          // formatter:'{a} {b}:{c} {d}%'
          formatter: function (params) {
            var result = ''
            var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1197b8"></span>'
            // 　　params.forEach(function (item) {
            // 　　　　result += item.axisValue + "</br>" + dotHtml + item.data
            // 　　})
            result = '<div style=" border-bottom:1px solid #EDEDED; padding:5px;" >' +
                            params.marker + params.data.name + '：' + params.percent.toFixed(1) + '%' +
                            '</div>' +
                            '<div style="text-align:center;margin-top:5px;font-size:16px;color:' + params.color + '">' +
                            params.data.value + '</div> '
            return result
          }

        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '80%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: datas.firstTotal, name: '首续期佣金' },
              { value: datas.hiredToAllowanceTotal, name: '聘才津贴' },
              { value: datas.comWelfareTotal, name: '综合福利津贴' },
              { value: datas.manageTotal, name: '管理+教育津贴' },
              { value: datas.otherIncomeTotal, name: '其他' },
              { value: datas.performTotal, name: '绩效和增员' },
              { value: datas.comDevelopTotal, name: '综合开拓佣金' }
            ]
          }
        ],
        color: ['#A4CE4A', '#EF8832', '#32C5F0', '#87449C', '#325490', '#749f83', '#ca8622']
      }
      // 绘制图表
      //   setTimeout(function () {
      myChart.setOption(options)
      //   }, 2000)
      setTimeout(function () {
        window.onresize = function () {
          myChart.resize()
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
#myIncome{
  height:100%;
  /* margin-bottom: 50px; */
  overflow-y: auto
}
#myIncome >>> .el-tabs__item{
  font-size: 15px;
  font-weight: Bold;
}
#myIncome >>> .el-collapse-item__arrow{
  line-height: 33px;
  /*display: inline;*/
}
#myIncome >>> .el-collapse-item__header.is-active {
  height:31px;
  background:rgba(247,247,247,1);
}
#myIncome >>> .el-collapse-item__header {
  height:31px;
  line-height: 31px;
  background:rgba(247,247,247,1);
}
/*#myIncome >>> .el-collapse-item__wrap {
   border-left: 1px solid #ebeef5;
   border-right: 1px solid #ebeef5;
}*/
#myIncome >>> .el-collapse-item__content {
  padding-bottom: 10px;
}
.first-Projectamount {
  height: 35px;
  line-height: 35px;
  overflow: hidden;
}
.first-content {
  min-height: 30px;
  line-height: 24px;
  overflow: hidden;
}
.main {
  width: 92%;
  margin: 0 auto;
  margin-top: 2%;
  padding: 2%;
  border: 1px solid #E5E5E5;
  height: 284px;
  background-color: #fff;
}

.main-header {
  position: relative;
  /* height: 0; */
}

.main-header label {
  font-size: 20px;
  font-family: Medium;
  color: #111111;
}
.main-content{width:100%; height:90%; position:relative;}
.content-top {
  /* height: 0; */
  float: left;
  text-align: center;
}
.content-top-left {
  height: 50px;
  float: left;
  margin-top: 25px;
}
.content-top-left label{
  color:#919191;
  font-size: 15px;
  display: block;
  margin-bottom:3px;
}
.content-top-left:first-child{
  padding-right: 28px;
  margin-right: 28px;
  border-right: 1px solid #E5E5E5;
}
.content-top-left:first-child span{
  color: #F68E1E;
  font-size: 25px;
}
.content-top-left:last-child span{
  color: #5976BA;
  font-size: 25px;
}
.myChart{ width:100%; height:100%;position:absolute; top: 0;}
.tables {
  width: 92%;
  margin: 0 auto;
  margin-top: 2%;
  padding: 2%;
  border: 1px solid #E5E5E5;
  /*height: 284px;*/
  background-color: #fff;
  margin-bottom: 100px;
}

.picker {
  z-index: 1001;
  position: absolute;
  right: 0;
  top: 0;
  color: #194793;
}

.tables .first-title {
  padding-left: 15px;
}
.tables .first-titles {
  font-size: 13px;
  padding:10px 0;
  overflow: hidden;
}
.first-titles span{
  /* display: inline-block; */
  display: block;
  float: left;
  width: 6.1%;
  text-align: center;
  color: #C6A970;
  line-height: 20px;
}
.first-contents{ 
  padding:10px 0;
  overflow: hidden;
  }
.first-contents span{
  font-size: 13px;
  /* display: inline-block; */
  display: block;
  float: left;
  width: 6.1%;
  text-align: center;
  /* overflow: hidden; */
  line-height: 20px;
}
/* 产品列左对齐 */
.first-contents span:nth-child(3){
  text-align: left;
  padding-left:5px;
  padding-right:5px;
  box-sizing: border-box;
}
.collapse-content{
  border: 1px solid #E5E5E5;
}

.first-Projectamount div{
  text-align: center;
  color: #C6A970;
  /* display: inline-block; */
  float: left;
  width: 24%;
  height: 14px;
  line-height: 14px;
  margin-top: 10px;
  border-right: 1px solid #C6A970;
}
/* .first-Projectamount div span{
  width: 45%;
  display: inline-block;
} */
/* .first-Projectamount i{
  display: inline-block;
  width: 32%;
} */
.first-Projectamount .border-right {
  border: none;
}
.first-content div{
  text-align: center;
  /* display: inline-block; */
  width: 24%;
  /* height: 18px;
  line-height: 18px; */
  float: left;
  border-right: 1px solid #fff;
}
/* .first-content div span{
  width: 45%;
  display: inline-block;

} */
/*.first-content i{
  display: inline-block;
  width: 26px;
}*/

.procon div span{
text-align: center;
width: 44%;
}
.procon div span.left{
  float:left;
  padding-left: 5%;
}
.procon div span.right{
  float: right;
  padding-right: 5%;
}
.procon div:last-child{
  border-right: 0;
}
/* .left{
  float:left;
  width: 45%;
  text-align: center;
  padding-left: 5%;
} */
/* .right{
  text-align: center;
  float: right;
  padding-right: 5%;
} */
.comment {
  width: 12px;
  height: 12px;
  vertical-align: middle;
  margin-left: 6px;
}
.el-collapse-item:last-child{
  border-left: 1px solid #ebeef5;
  border-right:1px solid #ebeef5
  }
#myIncome >>> .titleHeader{
  position: fixed;
  top: 60px;
  width: 83.4%;
  height: 40px;
  background-color: #ffffff;
  z-index: 999;
}
#myIncome >>> .el-tabs__content{
  position: inherit;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/myIncome.vue